const RISK_CONFIG = {
    high: {
        color: 'var(--error-light-color)',
        bgColor: 'rgba(255, 0, 0, 0.2)'
    },
    moderate: {
        color: 'var(--warning-color)',
        bgColor: 'rgba(255, 98, 0, 0.2)'
    },
    low: {
        color: 'var(--success-dark-color)',
        bgColor: 'rgba(31, 125, 12, 0.2)'
    }
};

function calculateRiskScore(userResponses, questionIds) {
    return userResponses
        .filter(r => !questionIds || questionIds.includes(r.questionId))
        .reduce((sum, r) => sum + (r.score || 0), 0);
}

function getRiskLevel(score, scoreThresholds) {
    if (score <= scoreThresholds.low) return 'low';
    if (score <= scoreThresholds.moderate) return 'moderate';

    return 'high';
}

const OVERALL_SCORE_THRESHOLDS = { low: 2, moderate: 10 };

const FINANCIAL_SEGMENT_QUESTION_ID = 10002;
const DEFAULT_FINANCIAL_SEGMENT = 'savings';

const FINANCIAL_SEGMENTS = {
    advisor: { label: 'Advisor security' },
    retirement: { label: 'Retirement' },
    savings: { label: 'Bank account' },
    'peace-of-mind': { label: 'Peace of mind' }
};

function getFinancialSegment(userResponses) {
    const response = userResponses.find(r => r.questionId === FINANCIAL_SEGMENT_QUESTION_ID);

    return response?.segment ?? DEFAULT_FINANCIAL_SEGMENT;
}

export {
    RISK_CONFIG,
    FINANCIAL_SEGMENTS,
    OVERALL_SCORE_THRESHOLDS,
    calculateRiskScore,
    getRiskLevel,
    getFinancialSegment
};
